// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoBillContainer_Ttyss {
  input[disabled],
  textarea[disabled],
  select[disabled] {
    background-color: transparent;
    border: none;
    outline: none;
  }
  input {
    height: 30px;
  }
  input,
  textarea,
  select,
  option {
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
    background-color: var(--f4-background);
    border: none;
    outline: none;
    padding: 4px;
    box-sizing: border-box;
  }


  .infoBill_IXIZR {
    display: flex;
    gap: 10px;
  }
  color: var(--_2-color);
  .light_30CrD {
    color: var(--_71717a-color);
    font-size: 13px;
  }
  p {
    margin: 0;
  }
  margin-top: 10px;
  .sectionContainer_vQz7V {
    display: flex;
    gap: 20px;
    padding: 10px 0;
    border-top: 2px solid #11a38129;
    border-bottom: 2px solid #11a38129;

    .column_NVliw {
      flex: 1 1;
      gap: 20px;
      display: flex;
      flex-direction: column;

      .row_sek3E {
        display: flex;
        justify-content: space-between;
        align-items: center;


        .state_P5Nr3 {
          display: flex;
          gap: 10px;
          align-items: center;
          select {
            background-color: transparent;
            border: none;
            outline: none;
            color: var(--009f7a-color);
            font-weight: bold;
            cursor: pointer;
          }
        }
      }
    }
  }
  .btnSectionsSelector_t0f3W {
    background-color: var(--f9-background);
    display: flex;
    padding: 4px;
    border-radius: 12px;
    -webkit-border-radius: 12px;
    -moz-border-radius: 12px;
    -ms-border-radius: 12px;
    -o-border-radius: 12px;
    svg{
      fill: var(--_b4-color);
    }
    button {
      flex: 1 1;
      border-radius: 8px;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      -ms-border-radius: 8px;
      -o-border-radius: 8px;
      cursor: pointer;
      font-weight: 600;
      border: 1px solid transparent;
      background-color: transparent;
      color: var(--_b4-color);
    }
    .sectionSelect_Jlz17 {
      background-color: var(--white-background);
      color: var(--_0d-color);
      border: 1px solid var(--_0000002b-border);
      svg{
        fill: var(--_2-color);
      }
    }
  }
  .skeletonScreenInfoBill_Su__R{
    margin: 50px 0;
  }
  .clientInfo_kEhbl {
    display: flex;
    border-bottom: 2px solid #11a38129;
    padding-top: 20px;
    padding-bottom: 70px;
    gap: 10px;
    height: 100px;

    textarea,
    input {
      border-radius: 4px;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      -ms-border-radius: 4px;
      -o-border-radius: 4px;
    }

    textarea {
      width: 100%;
      height: 100%;
      resize: none;
      box-sizing: border-box;
    }
    input {
      width: 100%;
      box-sizing: border-box;
    }
    .column_NVliw {
      flex: 1 1;
      height: 100%;
      gap: 10px;
      display: flex;
      flex-direction: column;
    }
  }




  .parameters_ruH5b {


    .parametersInfo_EGhVJ { 
      border-bottom: 2px solid #11a38129;
      display: flex;
      flex-direction: column;
      gap: 10px;
      transition: all 300ms;
      -webkit-transition: all 300ms;
      -moz-transition: all 300ms;
      -ms-transition: all 300ms;
      -o-transition: all 300ms;
      overflow: hidden;
      interpolate-size: allow-keywords;
      .articleTitle_HILAT {
        display: flex;
        justify-content: space-between;
        span {
          color: #92959865;
        }
        div {
          text-decoration: underline;
        }
      }
      .parametersInfoContainer_YUaJj {
        display: flex;
        gap: 10px;

        .column_NVliw {
          flex: 1 1;
          input {
            width: 100%;
            outline: none;
            border: none;
            padding: 8px;
            box-sizing: border-box;
            border-radius: 8px;
            -webkit-border-radius: 8px;
            -moz-border-radius: 8px;
            -ms-border-radius: 8px;
            -o-border-radius: 8px;
          }
        }
      }
    }

    .seeParameters_WqODO {
      padding: 12px 0;
      border-bottom: 2px solid #11a38129;
      p {
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        width: fit-content;
      }
      img {
        transition: transform 500ms;
        -webkit-transition: transform 500ms;
        -moz-transition: transform 500ms;
        -ms-transition: transform 500ms;
        -o-transition: transform 500ms;
      }
      .arrowDown_mqw8Y {
        transform: rotate(180deg);
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -o-transform: rotate(180deg);
      }
    }
  }
}



.articleBill_vt_5s {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  transition: all 300ms;
  -webkit-transition: all 300ms;
  -moz-transition: all 300ms;
  -ms-transition: all 300ms;
  -o-transition: all 300ms;
  overflow: hidden;
  interpolate-size: allow-keywords;
  .delete_M5B3M {
    height: 15px;
    width: 15px;
  }
  img {
    height: 80px;
    width: 80px;
  }
  .articleTitle_HILAT {
    display: flex;
    justify-content: space-between;
    span {
      color: #92959865;
    }
    a {
      color: black;
    }
  }

  .articleBody_cyJgF {
    display: flex;
    gap: 20px;
    align-items: center;
    .grab_Fc7LW {
      display: flex;
      align-items: center;
      gap: 5px;
      .icon_rKqry {
        cursor: pointer;
      }
    }
    .info_aehTv {
      width: 100%;
      display: flex;
      flex-direction: column;


      .test_SBEbV {
        width: 100%;
        display: flex;
        gap: 10px;
        box-sizing: border-box;
        flex: 1 1;
      }
      .leftInfo_WjAwU {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 62%;
      }
     
    }
  }
}
.light_30CrD {
  color: var(--_71717a-color);
}

.delete_M5B3M {
  background-color: #dc3545;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}

.quantityContainer_gaqt2{
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
  >div{
    flex: 1 1;
  }
}


.infoContainerWrapper_LAjlf {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0;
  justify-content: space-between;
}

.infoContainer_Dp26F {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  padding: 0;

  div {
    color: var(--_1f184b-color);
    font-size: 12px;
    font-weight: 500;
  }

  span {
    color: var(--_1f184b-color);
    font-size: 12px;
    font-weight: 300;

    @media (width<=768px) {

      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.editableInputHeader_noBJK {
  p {
    margin: 0;
  }
}

.contentContainer_h_EXt {
  &.active_bcyHx {
    display: block;
  }

  &.disabled_MhPT0 {
    display: none;
  }
}

.inputTypeClient_eTrrY {
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 400;
  min-height: 21px !important;
  background-color: var(--f4-background);
  border-radius: 5px;
  box-sizing: border-box;
  width: 100%;
  padding: 12px;

  &::placeholder {
    color: var(--_75-color);
  }
}

.keywordContainer_MI2Gx {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 9px 0;

  .keyword_DLsRt {
    display: flex;
    gap: 9px;
    padding: 3px 12px;
    border-radius: 30px;
    border: 1px solid var(--e0e3e6-border);
    align-items: center;
  }
}

.cardTypesContainer_En2Hs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 9px 0;
}

.singleTypeCard_ORDEq {
  display: flex;
  gap: 9px;
  padding: 3px 12px;
  border-radius: 30px;
  border: 1px solid var(--e0e3e6-border) ;

  span {
    font-size: 12px;
    font-weight: 400;
    color: var(--_2a2e32-color);
    -webkit-user-select: none;
            user-select: none;
  }
}

.messageConfigurationContainer_dyLsm {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.selectedVariablesContainer_u2fzv {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 10px 0;

  .selectedVariables_hcvDO {
    display: flex;
    gap: 9px;
    padding: 3px 12px;
    border-radius: 30px;
    border: 1px solid var(--e0e3e6-border) ;
    align-items: center;
    width: fit-content;
  }
}

  .inputContainer_Wc1Jq {
    display: flex;
    width: 100%;
    align-items: center;
    background-color: var(--f4-background);
    input::placeholder {
      color: var(--_71717a-color);
    }
  }

    .inputContainer_Wc1Jq {
    padding: 5px;
    position:relative;
    box-sizing: border-box;
    margin-top: 10px;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    resize: none;
    .searchContactInput_t0zfP {
      font-size: 18px;
      font-weight: 500;
      margin: 0;
      width: 100%;
      border-radius: 8px;
      padding: 6px;
      border: none;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      -ms-border-radius: 8px;
      -o-border-radius: 8px;
      background-color: var(--f4-background);
      outline: none;
    }
  }

  .searchContainerIcon_pFG4O {
    background-color: var(--ececf1-background);
    padding: 4px;
    border-radius: 4px;
    height: 10px;
    width: 10px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
    cursor: pointer;
  }
  .inputContainerNew_nELB3{
    position: relative;
  }`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/InfoBill/InfoBill.module.css"],"names":[],"mappings":"AAAA;EACE;;;IAGE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;;;;IAIE,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,sCAAsC;IACtC,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,sBAAsB;EACxB;;;EAGA;IACE,aAAa;IACb,SAAS;EACX;EACA,sBAAsB;EACtB;IACE,2BAA2B;IAC3B,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA,gBAAgB;EAChB;IACE,aAAa;IACb,SAAS;IACT,eAAe;IACf,+BAA+B;IAC/B,kCAAkC;;IAElC;MACE,SAAO;MACP,SAAS;MACT,aAAa;MACb,sBAAsB;;MAEtB;QACE,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;;;QAGnB;UACE,aAAa;UACb,SAAS;UACT,mBAAmB;UACnB;YACE,6BAA6B;YAC7B,YAAY;YACZ,aAAa;YACb,0BAA0B;YAC1B,iBAAiB;YACjB,eAAe;UACjB;QACF;MACF;IACF;EACF;EACA;IACE,sCAAsC;IACtC,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB;MACE,sBAAsB;IACxB;IACA;MACE,SAAO;MACP,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB,eAAe;MACf,gBAAgB;MAChB,6BAA6B;MAC7B,6BAA6B;MAC7B,uBAAuB;IACzB;IACA;MACE,yCAAyC;MACzC,uBAAuB;MACvB,yCAAyC;MACzC;QACE,qBAAqB;MACvB;IACF;EACF;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,kCAAkC;IAClC,iBAAiB;IACjB,oBAAoB;IACpB,SAAS;IACT,aAAa;;IAEb;;MAEE,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;IACvB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,YAAY;MACZ,sBAAsB;IACxB;IACA;MACE,WAAW;MACX,sBAAsB;IACxB;IACA;MACE,SAAO;MACP,YAAY;MACZ,SAAS;MACT,aAAa;MACb,sBAAsB;IACxB;EACF;;;;;EAKA;;;IAGE;MACE,kCAAkC;MAClC,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,qBAAqB;MACrB,6BAA6B;MAC7B,0BAA0B;MAC1B,yBAAyB;MACzB,wBAAwB;MACxB,gBAAgB;MAChB,gCAAgC;MAChC;QACE,aAAa;QACb,8BAA8B;QAC9B;UACE,gBAAgB;QAClB;QACA;UACE,0BAA0B;QAC5B;MACF;MACA;QACE,aAAa;QACb,SAAS;;QAET;UACE,SAAO;UACP;YACE,WAAW;YACX,aAAa;YACb,YAAY;YACZ,YAAY;YACZ,sBAAsB;YACtB,kBAAkB;YAClB,0BAA0B;YAC1B,uBAAuB;YACvB,sBAAsB;YACtB,qBAAqB;UACvB;QACF;MACF;IACF;;IAEA;MACE,eAAe;MACf,kCAAkC;MAClC;QACE,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,eAAe;QACf,kBAAkB;MACpB;MACA;QACE,2BAA2B;QAC3B,mCAAmC;QACnC,gCAAgC;QAChC,+BAA+B;QAC/B,8BAA8B;MAChC;MACA;QACE,yBAAyB;QACzB,iCAAiC;QACjC,8BAA8B;QAC9B,6BAA6B;QAC7B,4BAA4B;MAC9B;IACF;EACF;AACF;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,gCAAgC;EAChC;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B;MACE,gBAAgB;IAClB;IACA;MACE,YAAY;IACd;EACF;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB;MACE,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR;QACE,eAAe;MACjB;IACF;IACA;MACE,WAAW;MACX,aAAa;MACb,sBAAsB;;;MAGtB;QACE,WAAW;QACX,aAAa;QACb,SAAS;QACT,sBAAsB;QACtB,SAAO;MACT;MACA;QACE,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,UAAU;MACZ;;IAEF;EACF;AACF;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX;IACE,SAAO;EACT;AACF;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;;EAEV;IACE,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;;IAEhB;;MAEE,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;MAC5B,gBAAgB;MAChB,uBAAuB;IACzB;EACF;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;;EAEb;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;;EAEb;IACE,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,sCAAsC;IACtC,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;;EAEvC;IACE,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAiB;YAAjB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;;EAEd;IACE,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;EAEE;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,sCAAsC;IACtC;MACE,2BAA2B;IAC7B;EACF;;IAEE;IACA,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;IACZ;MACE,eAAe;MACf,gBAAgB;MAChB,SAAS;MACT,WAAW;MACX,kBAAkB;MAClB,YAAY;MACZ,YAAY;MACZ,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB,sCAAsC;MACtC,aAAa;IACf;EACF;;EAEA;IACE,0CAA0C;IAC1C,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB","sourcesContent":[".infoBillContainer {\n  input[disabled],\n  textarea[disabled],\n  select[disabled] {\n    background-color: transparent;\n    border: none;\n    outline: none;\n  }\n  input {\n    height: 30px;\n  }\n  input,\n  textarea,\n  select,\n  option {\n    border-radius: 4px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    -ms-border-radius: 4px;\n    -o-border-radius: 4px;\n    background-color: var(--f4-background);\n    border: none;\n    outline: none;\n    padding: 4px;\n    box-sizing: border-box;\n  }\n\n\n  .infoBill {\n    display: flex;\n    gap: 10px;\n  }\n  color: var(--_2-color);\n  .light {\n    color: var(--_71717a-color);\n    font-size: 13px;\n  }\n  p {\n    margin: 0;\n  }\n  margin-top: 10px;\n  .sectionContainer {\n    display: flex;\n    gap: 20px;\n    padding: 10px 0;\n    border-top: 2px solid #11a38129;\n    border-bottom: 2px solid #11a38129;\n\n    .column {\n      flex: 1;\n      gap: 20px;\n      display: flex;\n      flex-direction: column;\n\n      .row {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n\n        .state {\n          display: flex;\n          gap: 10px;\n          align-items: center;\n          select {\n            background-color: transparent;\n            border: none;\n            outline: none;\n            color: var(--009f7a-color);\n            font-weight: bold;\n            cursor: pointer;\n          }\n        }\n      }\n    }\n  }\n  .btnSectionsSelector {\n    background-color: var(--f9-background);\n    display: flex;\n    padding: 4px;\n    border-radius: 12px;\n    -webkit-border-radius: 12px;\n    -moz-border-radius: 12px;\n    -ms-border-radius: 12px;\n    -o-border-radius: 12px;\n    svg{\n      fill: var(--_b4-color);\n    }\n    button {\n      flex: 1;\n      border-radius: 8px;\n      -webkit-border-radius: 8px;\n      -moz-border-radius: 8px;\n      -ms-border-radius: 8px;\n      -o-border-radius: 8px;\n      cursor: pointer;\n      font-weight: 600;\n      border: 1px solid transparent;\n      background-color: transparent;\n      color: var(--_b4-color);\n    }\n    .sectionSelect {\n      background-color: var(--white-background);\n      color: var(--_0d-color);\n      border: 1px solid var(--_0000002b-border);\n      svg{\n        fill: var(--_2-color);\n      }\n    }\n  }\n  .skeletonScreenInfoBill{\n    margin: 50px 0;\n  }\n  .clientInfo {\n    display: flex;\n    border-bottom: 2px solid #11a38129;\n    padding-top: 20px;\n    padding-bottom: 70px;\n    gap: 10px;\n    height: 100px;\n\n    textarea,\n    input {\n      border-radius: 4px;\n      -webkit-border-radius: 4px;\n      -moz-border-radius: 4px;\n      -ms-border-radius: 4px;\n      -o-border-radius: 4px;\n    }\n\n    textarea {\n      width: 100%;\n      height: 100%;\n      resize: none;\n      box-sizing: border-box;\n    }\n    input {\n      width: 100%;\n      box-sizing: border-box;\n    }\n    .column {\n      flex: 1;\n      height: 100%;\n      gap: 10px;\n      display: flex;\n      flex-direction: column;\n    }\n  }\n\n\n\n\n  .parameters {\n\n\n    .parametersInfo { \n      border-bottom: 2px solid #11a38129;\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      transition: all 300ms;\n      -webkit-transition: all 300ms;\n      -moz-transition: all 300ms;\n      -ms-transition: all 300ms;\n      -o-transition: all 300ms;\n      overflow: hidden;\n      interpolate-size: allow-keywords;\n      .articleTitle {\n        display: flex;\n        justify-content: space-between;\n        span {\n          color: #92959865;\n        }\n        div {\n          text-decoration: underline;\n        }\n      }\n      .parametersInfoContainer {\n        display: flex;\n        gap: 10px;\n\n        .column {\n          flex: 1;\n          input {\n            width: 100%;\n            outline: none;\n            border: none;\n            padding: 8px;\n            box-sizing: border-box;\n            border-radius: 8px;\n            -webkit-border-radius: 8px;\n            -moz-border-radius: 8px;\n            -ms-border-radius: 8px;\n            -o-border-radius: 8px;\n          }\n        }\n      }\n    }\n\n    .seeParameters {\n      padding: 12px 0;\n      border-bottom: 2px solid #11a38129;\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        cursor: pointer;\n        width: fit-content;\n      }\n      img {\n        transition: transform 500ms;\n        -webkit-transition: transform 500ms;\n        -moz-transition: transform 500ms;\n        -ms-transition: transform 500ms;\n        -o-transition: transform 500ms;\n      }\n      .arrowDown {\n        transform: rotate(180deg);\n        -webkit-transform: rotate(180deg);\n        -moz-transform: rotate(180deg);\n        -ms-transform: rotate(180deg);\n        -o-transform: rotate(180deg);\n      }\n    }\n  }\n}\n\n\n\n.articleBill {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n  transition: all 300ms;\n  -webkit-transition: all 300ms;\n  -moz-transition: all 300ms;\n  -ms-transition: all 300ms;\n  -o-transition: all 300ms;\n  overflow: hidden;\n  interpolate-size: allow-keywords;\n  .delete {\n    height: 15px;\n    width: 15px;\n  }\n  img {\n    height: 80px;\n    width: 80px;\n  }\n  .articleTitle {\n    display: flex;\n    justify-content: space-between;\n    span {\n      color: #92959865;\n    }\n    a {\n      color: black;\n    }\n  }\n\n  .articleBody {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    .grab {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      .icon {\n        cursor: pointer;\n      }\n    }\n    .info {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n\n\n      .test {\n        width: 100%;\n        display: flex;\n        gap: 10px;\n        box-sizing: border-box;\n        flex: 1;\n      }\n      .leftInfo {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        width: 62%;\n      }\n     \n    }\n  }\n}\n.light {\n  color: var(--_71717a-color);\n}\n\n.delete {\n  background-color: #dc3545;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n}\n\n.quantityContainer{\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  width: 100%;\n  >div{\n    flex: 1;\n  }\n}\n\n\n.infoContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 0;\n  justify-content: space-between;\n}\n\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  padding: 0;\n\n  div {\n    color: var(--_1f184b-color);\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  span {\n    color: var(--_1f184b-color);\n    font-size: 12px;\n    font-weight: 300;\n\n    @media (width<=768px) {\n\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n}\n\n.editableInputHeader {\n  p {\n    margin: 0;\n  }\n}\n\n.contentContainer {\n  &.active {\n    display: block;\n  }\n\n  &.disabled {\n    display: none;\n  }\n}\n\n.inputTypeClient {\n  border: none;\n  outline: none;\n  font-size: 14px;\n  font-weight: 400;\n  min-height: 21px !important;\n  background-color: var(--f4-background);\n  border-radius: 5px;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px;\n\n  &::placeholder {\n    color: var(--_75-color);\n  }\n}\n\n.keywordContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 9px 0;\n\n  .keyword {\n    display: flex;\n    gap: 9px;\n    padding: 3px 12px;\n    border-radius: 30px;\n    border: 1px solid var(--e0e3e6-border);\n    align-items: center;\n  }\n}\n\n.cardTypesContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 9px 0;\n}\n\n.singleTypeCard {\n  display: flex;\n  gap: 9px;\n  padding: 3px 12px;\n  border-radius: 30px;\n  border: 1px solid var(--e0e3e6-border) ;\n\n  span {\n    font-size: 12px;\n    font-weight: 400;\n    color: var(--_2a2e32-color);\n    user-select: none;\n  }\n}\n\n.messageConfigurationContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.selectedVariablesContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 10px 0;\n\n  .selectedVariables {\n    display: flex;\n    gap: 9px;\n    padding: 3px 12px;\n    border-radius: 30px;\n    border: 1px solid var(--e0e3e6-border) ;\n    align-items: center;\n    width: fit-content;\n  }\n}\n\n  .inputContainer {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    background-color: var(--f4-background);\n    input::placeholder {\n      color: var(--_71717a-color);\n    }\n  }\n\n    .inputContainer {\n    padding: 5px;\n    position:relative;\n    box-sizing: border-box;\n    margin-top: 10px;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    resize: none;\n    .searchContactInput {\n      font-size: 18px;\n      font-weight: 500;\n      margin: 0;\n      width: 100%;\n      border-radius: 8px;\n      padding: 6px;\n      border: none;\n      -webkit-border-radius: 8px;\n      -moz-border-radius: 8px;\n      -ms-border-radius: 8px;\n      -o-border-radius: 8px;\n      background-color: var(--f4-background);\n      outline: none;\n    }\n  }\n\n  .searchContainerIcon {\n    background-color: var(--ececf1-background);\n    padding: 4px;\n    border-radius: 4px;\n    height: 10px;\n    width: 10px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    -ms-border-radius: 4px;\n    -o-border-radius: 4px;\n    cursor: pointer;\n  }\n  .inputContainerNew{\n    position: relative;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoBillContainer": `infoBillContainer_Ttyss`,
	"infoBill": `infoBill_IXIZR`,
	"light": `light_30CrD`,
	"sectionContainer": `sectionContainer_vQz7V`,
	"column": `column_NVliw`,
	"row": `row_sek3E`,
	"state": `state_P5Nr3`,
	"btnSectionsSelector": `btnSectionsSelector_t0f3W`,
	"sectionSelect": `sectionSelect_Jlz17`,
	"skeletonScreenInfoBill": `skeletonScreenInfoBill_Su__R`,
	"clientInfo": `clientInfo_kEhbl`,
	"parameters": `parameters_ruH5b`,
	"parametersInfo": `parametersInfo_EGhVJ`,
	"articleTitle": `articleTitle_HILAT`,
	"parametersInfoContainer": `parametersInfoContainer_YUaJj`,
	"seeParameters": `seeParameters_WqODO`,
	"arrowDown": `arrowDown_mqw8Y`,
	"articleBill": `articleBill_vt_5s`,
	"delete": `delete_M5B3M`,
	"articleBody": `articleBody_cyJgF`,
	"grab": `grab_Fc7LW`,
	"icon": `icon_rKqry`,
	"info": `info_aehTv`,
	"test": `test_SBEbV`,
	"leftInfo": `leftInfo_WjAwU`,
	"quantityContainer": `quantityContainer_gaqt2`,
	"infoContainerWrapper": `infoContainerWrapper_LAjlf`,
	"infoContainer": `infoContainer_Dp26F`,
	"editableInputHeader": `editableInputHeader_noBJK`,
	"contentContainer": `contentContainer_h_EXt`,
	"active": `active_bcyHx`,
	"disabled": `disabled_MhPT0`,
	"inputTypeClient": `inputTypeClient_eTrrY`,
	"keywordContainer": `keywordContainer_MI2Gx`,
	"keyword": `keyword_DLsRt`,
	"cardTypesContainer": `cardTypesContainer_En2Hs`,
	"singleTypeCard": `singleTypeCard_ORDEq`,
	"messageConfigurationContainer": `messageConfigurationContainer_dyLsm`,
	"selectedVariablesContainer": `selectedVariablesContainer_u2fzv`,
	"selectedVariables": `selectedVariables_hcvDO`,
	"inputContainer": `inputContainer_Wc1Jq`,
	"searchContactInput": `searchContactInput_t0zfP`,
	"searchContainerIcon": `searchContainerIcon_pFG4O`,
	"inputContainerNew": `inputContainerNew_nELB3`
};
export default ___CSS_LOADER_EXPORT___;
